import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import { P as PaymentMethodCode } from '../../payment-5CMab_Gs.js';

// Move "CreditCard" to the first option
const sortPaymentMethods = (paymentMethods) => paymentMethods.sort((a, b) => {
    if (a.code === PaymentMethodCode.CreditCards)
        return -1; // "CreditCard" always stay first
    if (b.code === PaymentMethodCode.CreditCards)
        return 1; // Move "CreditCard" to be first
    return 0;
});

export { sortPaymentMethods };
//# sourceMappingURL=helper.js.map
